import gql from 'graphql-tag';

export const queryForWhoReportsToMe = gql`
  query queryForWhoReportsToMe($email: String) {
    queryForWhoReportsToMe(email: $email) {
      id
      firstName
      lastName
    }
  }
`;
